import{createContext as e}from"react";var r=e({activeIndex:null,isOpen:!1});export{r as MenuContext};
//# sourceMappingURL=PopoverMenuContext.js.map
